
function CheckMoreButtons({ onNext, nextBtnRef }) {
  const handleRedoACB = () => {
    window.location.reload();
  };

  return (
    <div
      className="checkmore-Container"
      id="check-more-btn"
      ref={nextBtnRef}
    >
      <div className="checkmore-btn redo" onClick={handleRedoACB}>
        Redo
      </div>
      <div
        className="checkmore-btn"
        onClick={() => onNext("success")}
      >
        Next
      </div>
    </div>
  );
}

export  {CheckMoreButtons};
